import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Portfolio from "./pages/Portfolio";
import VenturesForm from "./pages/VenturesForm";
import Studio from "./pages/Studio";
import Finance from "./pages/Finance";
import FinanceBlog from "./pages/FinanceBlog";
import FinanceCommunity from "./pages/FinanceCommunity";
import FinanceCommunities from "./pages/FinanceCommunities";
import Build from "./pages/Build";
import Develop from "./pages/Develop";
import Admin from "./pages/Admin";
import Shop from "./pages/Shop";
import Health from "./health/Health";

// Detect subdomain from hostname
const hostname = window.location.hostname;
const _devOverride = process.env.NODE_ENV === 'development'
  ? new URLSearchParams(window.location.search).get("subdomain")
  : null;

function getSubdomain() {
  if (_devOverride) return _devOverride;
  const parts = hostname.split(".");
  if (parts.length > 2) return parts[0];
  return "main";
}

const subdomain = getSubdomain();

function App() {
  if (subdomain === "venture") return <VenturesForm />;
  if (subdomain === "studio")  return <Studio />;
  if (subdomain === "build")   return <Build />;
  if (subdomain === "develop") return <Develop />;
  if (subdomain === "admin")   return <Admin />;
  if (subdomain === "shop")    return <Shop />;
  if (subdomain === "health")  return <Health />;
  if (subdomain === "finance") return (
    <BrowserRouter>
      <Routes>
        <Route path="/"             element={<Finance />} />
        <Route path="/blog/:id"     element={<FinanceBlog />} />
        <Route path="/community"         element={<FinanceCommunities />} />
        <Route path="/community/:slug"   element={<FinanceCommunity />} />
      </Routes>
    </BrowserRouter>
  );
  return <Portfolio />;
}

export default App;
